import { CurrentUserQuery } from "services/graphql/generated";

/**
 * We use this function to determine the results of "/status/auth" response
 * It returns object with empty fields if user is not logged in.
 */
export const isLoggedIn = (
  user?: CurrentUserQuery["currentUser"] | null
): boolean => !!user?.id;
